<div *ngIf="step === 2" class="requirement row" style="position: relative;">

    <div class="d-flex align-items-center">
        <p class="no-margin-bottom me-3">
            <label for="requirement-number" class="requirement-number" [ngClass]="requirement.status === 'DISCARDED' ? 'requirement-discarded' : ''" style="color: #C44727">{{ requirement.number }}</label>
        </p>
        <p class="no-margin-bottom">
            <label for="requirement-title" class="requirement-title">{{ requirement.title }}</label>
        </p>
    </div>

    <div *ngIf="isAnyEvidenceInProgress; then isEvidenceInProgress else isNotEvidenceInProgress"></div>

    <ng-template #isEvidenceInProgress>

        <div class="requirement-title-container">
            <div [ngSwitch]="receivedEvidence.status">
                <div *ngSwitchCase="'RECEIVED'">
                    <ng-container
                        *ngTemplateOutlet="evidenceReceived; context: { evidence: receivedEvidence }"></ng-container>
                </div>
                <div *ngSwitchCase="'PREVIEW_AVAILABLE'">
                    <ng-container
                        *ngTemplateOutlet="evidencePreviewAvailable; context: { evidence: receivedEvidence }"></ng-container>
                </div>
            </div>
        </div>

    </ng-template>

    <ng-template #isNotEvidenceInProgress>
        <div class="col-10 col-lg-11">

            <div class="select2-wrapper">
                <select2 [data]="countryList" [value]="selectedCountry" [templates]="template"
                    class="select2 custom-select2" (update)="onCountryChange($event)"
                    [disabled]="sendButton?.isLoading || isCountryListLoading" [placeholder]="getPlaceHolder()"
                    listPosition="above">

                    <ng-template #template let-data="data" let-label="label">
                        <div class="country-container">
                            <div *ngIf="data?.image">
                                <img [src]="data.image" alt="{{ label }}" />
                            </div>
                            <span>{{ label }}</span>
                        </div>
                    </ng-template>
                </select2>

                <div *ngIf="isCountryListLoading && !sendButton?.isLoading" class="spinner-inside-select"></div>
            </div>
            <div *ngIf="requirement.countrySearchStatus === countrySearchStatusEnum.NO_COUNTRIES">
                <div class="row provider-not-found">
                    <div class="col-md-12 mt-2 pt-2">
                        <table aria-hidden="true">
                            <th aria-hidden="true"></th>
                            <tr>
                                <td><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#C44727"
                                        class="bi bi-exclamation-octagon-fill fa-lg right-margin" viewBox="0 0 16 16">
                                        <path
                                            d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                                    </svg></td>
                                <td><b>{{'EV_REQUESTED.DOC_PROVIDER_NOT_FOUND' | translate}}</b></td>
                            </tr>
                            <tr *ngIf="errorMessage === 'undenfined'">
                                <td></td>
                                <td>
                                    <p>{{'EV_REQUESTED.ADDITIONAL_INFO' | translate}}</p>
                                </td>
                            </tr>
                            <tr *ngIf="errorMessage !== 'undenfined'">
                                <td></td>
                                <td>
                                    <p [innerHtml]="errorMessage"></p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-2 col-lg-1">
            <app-loader-button [disabled]="!selectedCountry || selectedCountry ==='null' || selectedCountry === 'NONE'"
                (buttonClicked)="searchEvidence()" [icon]="'fa fa-search'" [text]="''"></app-loader-button>
        </div>

        <div *ngIf="isSearchDone">
            <div *ngIf="isProviderFound; then providerFound else providerNotFound"></div>

            <ng-template #providerNotFound>
                <div class="row provider-not-found">
                    <div class="col-md-12 mt-2 pt-2">
                        <table aria-hidden="true">
                            <th aria-hidden="true"></th>
                            <tr>
                                <td><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#C44727"
                                        class="bi bi-exclamation-octagon-fill fa-lg right-margin" viewBox="0 0 16 16">
                                        <path
                                            d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                                    </svg></td>
                                <td><b>{{'EV_REQUESTED.DOC_PROVIDER_NOT_FOUND' | translate}}</b></td>
                            </tr>
                            <tr *ngIf="errorMessage === 'undenfined'">
                                <td></td>
                                <td>
                                    <p>{{'EV_REQUESTED.ADDITIONAL_INFO' | translate}}</p>
                                </td>
                            </tr>
                            <tr *ngIf="errorMessage !== 'undenfined'">
                                <td></td>
                                <td>
                                    <p [innerHtml]="errorMessage"></p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </ng-template>

            <ng-template #providerFound>
                <div *ngIf="!showWarningForAdditionalInfo()">
                    <div class="row provider-found mt-3 mb-3">
                        <div *ngIf="requirement.haveProviders" class="col-md-12 mt-2 pt-2">
                            <table aria-hidden="true">
                                <th aria-hidden="true"></th>
                                <tr>
                                    <td><i class="fa fa-info-circle icon-background fa-lg" aria-hidden="true"></i></td>
                                    <td><b>{{'EV_REQUESTED.DOC_PROVIDER_FOUND' | translate}}</b></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <p>{{'EV_REQUESTED.DOC_PROVIDER_FOUND_DESC' | translate}}</p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <div *ngIf="showWarningForAdditionalInfo()">
                    <div class="row provider-warning mt-3 mb-3">
                        <div class="col-md-12 mt-2 pt-2">
                            <table aria-hidden="true">
                                <th aria-hidden="true"></th>
                                <tr>
                                    <td><i class="fa fa-triangle-exclamation icon-background-warning fa-lg"
                                            aria-hidden="true"></i></td>
                                    <td><b>{{'EV_REQUESTED.DOC_PROVIDER_NOT_FOUND' | translate}}</b></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <p>{{'EV_REQUESTED.ADDITIONAL_INFO' | translate}}</p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <div *ngFor="let provider of requirement.providers; let i = index"
                    [ngStyle]="{ 'border-bottom': (i < requirement.providers.length - 1 && !(provider.message && !provider.message.includes('DSD:ERR:0005')) ) ? '1px solid #E7E7E7' : 'none' }">
                    <div class="d-flex mb-1 mt-1"
                        *ngIf="!(provider.message && !provider.message.includes('DSD:ERR:0005'))">
                        <div class="me-2 mt-1 ml-3">
                            <input type="radio" [name]="'radio_' + requirement.number"
                                [disabled]="provider.accessServiceIdentifier === null" [value]="provider"
                                [(ngModel)]="selectedProvider" (change)="providerSelected(provider, i)">
                        </div>
                        <div class="w-100">
                            <b class="align-top">{{ provider.evidenceTitle | multiLanguage: lang }}</b>

                            <div *ngIf="provider.showJurisdictionSelect" class="mb-3">
                                <div *ngFor="let jurisdictionFormArray of jurisdictionSelectArray; let j = index">
                                    <div>
                                        <div *ngFor="let jurisdictionFormGroup of jurisdictionFormArray.controls; let k = index"
                                            class="jurisdiction-group">
                                            <div [formGroup]="jurisdictionForm" (ngSubmit)="onJurisdictionSubmit()"
                                                class="juristiction-select">
                                                {{'EV_REQUESTED.SELECT_REGION' | translate}}
                                                <select2 [data]="jurisdictionListsArrays[i][j]" class="select2"
                                                    (update)="changeJurisdictionValueNew($event, j, k)">
                                                </select2>
                                            </div>
                                            <div class="row provider-not-found jurisdiction-error"
                                                *ngIf="provider.errorMessage">
                                                <table aria-hidden="true">
                                                    <th aria-hidden="true"></th>
                                                    <tr>
                                                        <td><svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                                height="16" fill="#C44727"
                                                                class="bi bi-exclamation-octagon-fill fa-lg right-margin"
                                                                viewBox="0 0 16 16">
                                                                <path
                                                                    d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                                                            </svg></td>
                                                        <td class="lg-description">
                                                            <b>{{'EV_REQUESTED.DOC_PROVIDER_NOT_FOUND' | translate}}</b>
                                                        </td>
                                                        <td>
                                                            <p class="sm-description"
                                                                [innerHtml]="provider.errorMessage"></p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td class="lg-description">
                                                            <p [innerHtml]="provider.errorMessage"></p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="provider.evidenceProviderClassifications" class="w-100 mb-3 d-inline-flex justify-content-between">
                                <div *ngFor="let providerClassification of provider.evidenceProviderClassifications; let i = index">
                                    <div *ngIf="providerClassification.type === 'codelist' && providerClassification.codeList" class="juristiction-select">
                                        {{'EV_REQUESTED.SELECT_REGION' | translate}}
                                        <select2 [data]="providerClassification.codeList" class="select2"
                                            (update)="providerClassification.selectedValue">
                                        </select2>
                                            
                                    </div>
                                    <div *ngIf="providerClassification.type === 'string'" class="juristiction-select">
                                        <label class="w-100" for="stringProviderClassification">{{ providerClassification.description | multiLanguage:lang }}</label>
                                        <input class="stringProviderClassification"
                                            [(ngModel)]="providerClassification.selectedValue" >
                                    </div>
                                    <div *ngIf="providerClassification.type === 'boolean'" class="juristiction-select">
                                        <label class="w-100" for="booleanProviderClassification">{{ providerClassification.description | multiLanguage:lang }}</label>
                                        <input class="booleanProviderClassification pr-1" type="checkbox"
                                            [(ngModel)]="providerClassification.selectedValue" >
                                    </div>
                                    <div class="row provider-not-found jurisdiction-error"
                                        *ngIf="provider.errorMessage">
                                        <table aria-hidden="true">
                                            <th aria-hidden="true"></th>
                                            <tr>
                                                <td><svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                        height="16" fill="#C44727"
                                                        class="bi bi-exclamation-octagon-fill fa-lg right-margin"
                                                        viewBox="0 0 16 16">
                                                        <path
                                                            d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                                                    </svg></td>
                                                <td class="lg-description">
                                                    <b>{{'EV_REQUESTED.DOC_PROVIDER_NOT_FOUND' | translate}}</b>
                                                </td>
                                                <td>
                                                    <p class="sm-description"
                                                        [innerHtml]="provider.errorMessage"></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td class="lg-description">
                                                    <p [innerHtml]="provider.errorMessage"></p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <button *ngIf="provider.evidenceProviderClassifications && provider.evidenceProviderClassifications.length > 0 && !provider.errorMessage" (click)="searchEvidenceProviderClassification(provider)">{{'EV_REQUESTED.SEARCH_PROVIDER' | translate}}</button>
                            </div>

                            <div *ngIf="provider.accessServiceIdentifier !== null">
                                <span>{{'EV_REQUESTED.PROVIDER' | translate}}: </span>
                                <span class="fw-bold">{{ provider.publisherName }}</span>
                            </div>

                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </ng-template>
</div>

<div *ngIf="step === 3" [hidden]="requirement.evidences.length === 0" class="requirement row"
    style="position: relative;">

    <div class="d-flex align-items-center">
        <p class="no-margin-bottom me-3">
            <label for="requirement-number" class="requirement-number">{{ requirement.number }}</label>
        </p>
        <p class="no-margin-bottom">
            <label for="requirement-title" class="requirement-title">{{ requirement.title }}</label>
        </p>
    </div>

    <div *ngFor="let evidence of requirement.evidences">
        <div class="row" *ngIf="evidence.selectedProvider !== null">
            <div class="requirement-title-container">
                <div [ngSwitch]="evidence.status">
                    <div *ngSwitchCase="'PENDING'">
                        <ng-container
                            *ngTemplateOutlet="evidencePendingOrError; context: { evidence: evidence }"></ng-container>
                    </div>
                    <div *ngSwitchCase="'ERROR'">
                        <ng-container
                            *ngTemplateOutlet="evidencePendingOrError; context: { evidence: evidence }"></ng-container>
                    </div>
                    <div *ngSwitchCase="'CANCEL'">
                        <ng-container
                            *ngTemplateOutlet="evidenceCanceled; context: { evidence: evidence }"></ng-container>
                    </div>
                    <div *ngSwitchCase="'RECEIVED'">
                        <ng-container
                            *ngTemplateOutlet="evidenceReceived; context: { evidence: evidence }"></ng-container>
                    </div>
                    <div *ngSwitchCase="'PREVIEW_AVAILABLE'">
                        <ng-container
                            *ngTemplateOutlet="evidencePreviewAvailable; context: { evidence: evidence }"></ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="step === 4" [hidden]="requirement.evidences.length === 0" class="requirement row"
    style="position: relative;">

    <div class="d-flex align-items-center">
        <p class="no-margin-bottom me-3">
            <label for="requirement-number" class="requirement-number">{{ requirement.number }}</label>
        </p>
        <p class="no-margin-bottom">
            <label for="requirement-title" class="requirement-title">{{ requirement.title }}</label>
        </p>
    </div>

    <div *ngFor="let evidence of requirement.evidences">
        <div class="row" *ngIf="evidence.selectedProvider !== null">
            <div class="requirement-title-container">

                <section>
                    <div class="inline_items">
                        <p><label for="evidence-title" class="evidence-title">{{ evidence.evidenceTitle |
                                multiLanguage:lang }}</label></p>
                        <div class="hr-line">
                            <hr>
                        </div>
                        <div [ngSwitch]="evidence.status">
                            <div *ngSwitchCase="'RECEIVED'">
                                <div class="evidence-status status-received">☑ {{'EV_REQUESTED.STATUS_RECEIVED'
                                    |
                                    translate}}</div>
                            </div>
                            <div *ngSwitchCase="'CANCEL'">
                                <div class="evidence-status status-cancel">🛇 {{'EV_REQUESTED.STATUS_CANCEL'
                                    |translate}}</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>

<ng-template #evidencePreviewAvailable let-evidence="evidence">
    <div class="container-title">
        <div class="evidence-title">{{ evidence.evidenceTitle | multiLanguage:lang }}</div>
        <div class="evidence-status status-pending">⚠ {{'EV_REQUESTED.STATUS_PENDING' | translate }}</div>
    </div>
    <div class="row evidence-waiting mt-2">
        <div class="col-md-12 mt-2 pt-2">
            <p><i class="loading"></i>{{'EV_REQUESTED.EVIDENCE_REQUESTED' | translate}}</p>
        </div>
    </div>
</ng-template>

<ng-template #evidenceReceived let-evidence="evidence">
    <div class="container-title">
        <div class="evidence-title">{{ evidence.evidenceTitle | multiLanguage:lang }}</div>
        <div class="evidence-status status-received">☑ {{'EV_REQUESTED.STATUS_RECEIVED' | translate }}</div>
    </div>
    <div>
        <span>{{'EV_REQUESTED.PROVIDER' | translate}}: </span>
        <span class="fw-bold">{{ evidence.selectedProvider !== undefined ? evidence.selectedProvider.publisherName :
            evidence.publisherName }}</span>
    </div>

    <div *ngIf="evidence.structuredData && evidence.structuredData.data">
        <div class="divider" style="width: 35%;"></div>
        <app-structured-data [structuredData]="evidence.structuredData" dataTitle="STRUCTURED_DATA.PROVIDER_DATA_TITLE"
            titleFontSize="14px"></app-structured-data>
    </div>

    <div class="mt-3">
        <button *ngIf="!isUserLogged" class="" (click)="viewDocument()">{{'EV_REQUESTED.TRANSLATED_DOCUMENTATION' |
            translate}}</button>
        <button class="search-loader-button" (click)="viewDocument()">{{'EV_REQUESTED.PREVIEW' |
            translate}}</button>
        <button class="cancel-button" (click)="deleteDocument(evidence)">{{'EV_REQUESTED.DELETE' |
            translate}}</button>

        <div *ngIf="evidence.base64File && isPdfAvailable" class="w-100">
            <div class="row">
                <ngx-extended-pdf-viewer class="pdf-viewer" [base64Src]="evidence.base64File" [height]="'98vh'"
                [showToolbar]="true"
                [showSidebarButton]="true"
                [showFindButton]="false"
                [showPagingButtons]="false"
                [showZoomButtons]="true"
                [showPresentationModeButton]="false"
                [showOpenFileButton]="false"
                [showPrintButton]="false"
                [showDownloadButton]="true"
                [showSecondaryToolbarButton]="false"
                [showRotateButton]="false"
                [showHandToolButton]="false"
                [showSpreadButton]="false"
                [showPropertiesButton]="false">
                </ngx-extended-pdf-viewer>
                <div class="mt-4" style="display: flex; justify-content: flex-end;"><button
                        (click)="viewDocument()">{{'EV_REQUESTED.CLOSE' | translate}}</button></div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #evidencePendingOrError let-evidence="evidence">
    <div class="container-title">
        <div class="evidence-title mt-2">{{ evidence.evidenceTitle | multiLanguage:lang }}</div>
        <div *ngIf="evidence.status === 'PENDING'" class="evidence-status status-pending">⚠
            {{'EV_REQUESTED.STATUS_PENDING' | translate}}</div>
        <div *ngIf="evidence.status === 'ERROR'" class="evidence-status-new status-error">☒
            {{'EV_REQUESTED.STATUS_ERROR' | translate }}</div>
    </div>
    <div>
        <span>{{'EV_REQUESTED.PROVIDER' | translate}}: </span>
        <span class="fw-bold">{{ evidence.publisherName ?? evidence.selectedProvider?.publisherName }}</span>
    </div>

    <div style="display: flex;">
        <div class="search-button">
            <td *ngIf="evidence.status === 'PENDING'">
                <app-loader-button class="search-loader-button" (buttonClicked)="searchDocument(evidence)"
                    [text]="translateText('EV_REQUESTED.SEARCH_DOC')">
                </app-loader-button>
            </td>
            <td *ngIf="evidence.status === 'ERROR'" style="white-space:nowrap;">
                <app-loader-button class="search-loader-button" (buttonClicked)="searchDocument(evidence)"
                    [text]="translateText('EV_REQUESTED.RETRY')">
                </app-loader-button>
            </td>
            <td><button class="cancel-button" (click)="setCancel(evidence)">{{'EV_REQUESTED.CANCEL' |
                    translate}}</button>
            </td>
        </div>
    </div>

</ng-template>

<ng-template #evidenceCanceled let-evidence="evidence">
    <div class="container-title">
        <div class="evidence-title mt-2">{{ evidence.evidenceTitle | multiLanguage:lang }}</div>
        <div class="evidence-status status-cancel">🛇 {{'EV_REQUESTED.STATUS_CANCEL' |
            translate}}</div>
    </div>
    <div>
        <span>{{'EV_REQUESTED.PROVIDER' | translate}}: </span>
        <span class="fw-bold">{{ evidence.publisherName ?? evidence.selectedProvider?.publisherName }}</span>
    </div>

    <div style="display: flex;">
        <div class="search-button" style="width: 160px;">
            <span>
                <table aria-hidden="true">
                    <th aria-hidden="true"></th>
                    <tr>
                        <td style="white-space:nowrap;">
                            <button class="revert-button" (click)="revertCancel(evidence)">
                                {{'EV_REQUESTED.REVERT_CANCEL' | translate}}
                            </button>
                        </td>
                    </tr>
                </table>
            </span>
        </div>
    </div>
</ng-template>